export enum FontDecoration {
  BOLD = 'bold',
  ITALIC = 'italic',
  UNDERLINE = 'underline',
}
